export const HEADING_COLOR = "#ffcd00" 
export const SHADOW_COLOR = "#ffeb9b"
export const BUTTON_STYLE = {
    textTransform: 'none',
  background: "#f2ca00",
  boxShadow: "0px 0px 7px 3px #ff8585"
}